import Home from './pages/Home'
import World from './pages/World'

export default {
    home: Home,
    world: World
}


// WEBPACK FOOTER //
// ./src/modules.js